module.exports = __webpack_public_path__ + "img/28.d9d2f471.png";